/**
 * @generated SignedSource<<fc63f4ab68c36c1780c701a003717dcc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type OnboardingType = "CLIENT" | "CONTRACTOR" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserReviews_userProfile$data = {
  readonly displayUsername: string;
  readonly firstName: string | null;
  readonly id: string;
  readonly lastName: string | null;
  readonly recommendationRequests: {
    readonly count: number;
  };
  readonly userReviews: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly associatedWork: {
          readonly paidProjectProfile: {
            readonly contractor: {
              readonly id: string;
            };
            readonly id: string;
          } | null;
          readonly portfolioProject: {
            readonly id: string;
          } | null;
          readonly productizedService: {
            readonly id: string;
          } | null;
        };
        readonly author: {
          readonly avatarImage: {
            readonly uid: string;
            readonly url: string;
          } | null;
          readonly displayUsername: string;
          readonly firstName: string | null;
          readonly id: string;
          readonly lastName: string | null;
          readonly onboardingType: OnboardingType;
          readonly organization: {
            readonly logoImage: {
              readonly id: string;
              readonly uid: string;
              readonly url: string;
            } | null;
            readonly name: string;
          } | null;
          readonly organizationV2: {
            readonly id: string;
          } | null;
        };
        readonly commentOnlyVisibleToRecipient: boolean;
        readonly createdAt: ContraAPIScalars.DateTime;
        readonly id: string;
        readonly isPositiveReview: boolean;
        readonly onlyVisibleToRecipient: boolean;
        readonly reviewText: string | null;
      };
    }>;
  };
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "UserReviews_userProfile";
};
export type UserReviews_userProfile$key = {
  readonly " $data"?: UserReviews_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserReviews_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayUsername",
  "storageKey": null
},
v4 = [
  (v0/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserReviews_userProfile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RecommendationRequestConnection",
      "kind": "LinkedField",
      "name": "recommendationRequests",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "isPositiveReview": true,
            "onlyVisibleToRecipient": false
          }
        }
      ],
      "concreteType": "UserReviewConnection",
      "kind": "LinkedField",
      "name": "userReviews",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserReviewEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserReview",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "commentOnlyVisibleToRecipient",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "onlyVisibleToRecipient",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPositiveReview",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "reviewText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserProfile",
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Organization",
                      "kind": "LinkedField",
                      "name": "organizationV2",
                      "plural": false,
                      "selections": (v4/*: any*/),
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "onboardingType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ContraImage",
                      "kind": "LinkedField",
                      "name": "avatarImage",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/),
                        (v6/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Organization",
                      "kind": "LinkedField",
                      "name": "organization",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ContraImage",
                          "kind": "LinkedField",
                          "name": "logoImage",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v5/*: any*/),
                            (v6/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserReviewAssociatedWork",
                  "kind": "LinkedField",
                  "name": "associatedWork",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PaidProjectProfile",
                      "kind": "LinkedField",
                      "name": "paidProjectProfile",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "UserProfile",
                          "kind": "LinkedField",
                          "name": "contractor",
                          "plural": false,
                          "selections": (v4/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PortfolioProject",
                      "kind": "LinkedField",
                      "name": "portfolioProject",
                      "plural": false,
                      "selections": (v4/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductizedService",
                      "kind": "LinkedField",
                      "name": "productizedService",
                      "plural": false,
                      "selections": (v4/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "userReviews(filter:{\"isPositiveReview\":true,\"onlyVisibleToRecipient\":false})"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "0f2f4189aa90f9e94ad89fa6dea68356";

export default node;
